import React from 'react'

const About = () => {
    return (
        <div className='flex flex-col items-start justify-center h-full'>
            <h3 className='pb-2 text-lg font-semibold'>About Me</h3>
            <p className="mx-auto text-sm tracking-wider">
                I am a Software Developer at Open Financial Technologies. I have completed a Bachelor's degree in
                Computer Science from Mar Athanasius College of Engineering, Kerala.
                Enthusiastic about AI/ML advancements and committed to continuous learning and improvement.
                <br /> <br />
                Let's geek out together and build something extraordinary!<br />
            </p>
        </div>
    )
}

export default About
